import LoadingStatus from 'enums/loadingStatus';
import { createSlice } from '@reduxjs/toolkit';
import initialState from './initialState';

const marketingCampaignPreferencesSlice = createSlice({
  name: 'marketingCampaignPreferences',
  initialState,
  reducers: {
    fetchUnsubscribe: (state) => {
      state.isFetchingUnsubscribe = LoadingStatus.Loading;
    },
    fetchUnsubscribeSucces: (state) => {
      state.isFetchingUnsubscribe = LoadingStatus.Succeeded;
    },
    fetchUnsubscribeError: (state) => {
      state.isFetchingUnsubscribe = LoadingStatus.Failed;
    },
    fetchUnsubscribeFeedback: (state) => {
      state.isFetchingUnsubscribeFeedback = LoadingStatus.Loading;
    },
    fetchUnsubscribeFeedbackSucces: (state) => {
      state.isFetchingUnsubscribeFeedback = LoadingStatus.Succeeded;
    },
    fetchUnsubscribeFeedbackError: (state) => {
      state.isFetchingUnsubscribeFeedback = LoadingStatus.Failed;
    }
  },
});

export default marketingCampaignPreferencesSlice;